import React from "react";
import { ProtectedUser } from "../../components";

function UserProtected (){
    return(
        <ProtectedUser />
    )
}

export default UserProtected